import { createSelector } from 'reselect';
import { Auth } from '@ipc/ipc-core';

const getAuth = state => state.global.auth;

export const getAuthState = createSelector(
  [getAuth], auth => new Auth(auth),
);

export const getAuthTokenState = createSelector(
  [getAuth], auth => auth.token,
);

export const getAuthRolesState = createSelector(
  [getAuth], auth => auth.roles,
);
